import { FC } from 'react';
import { IRecording } from '../../recording/RecordingState';
import { SelectableText } from '../../components/SelectableText';

export const AIOverview: FC<{ recording: IRecording; }> = ({ recording }) => {
    return recording?.summary?.highLevelSummary && (
        <SelectableText>{recording.summary.highLevelSummary}</SelectableText>
    );
};
